// App
export const APP_SESSION_INFO_SET = 'APP_SESSION_INFO_SET';
export const APP_SNACKBAR_SHOW = 'APP_SNACKBAR_SHOW';

// Nav
export const NAV_SET_BREADCRUMBS = 'NAV_SET_BREADCRUMBS';

/*
  -----------------

  Booking

  -----------------
 */
export const BOOKING_RESET_STATE = 'BOOKING_RESET_STATE';
export const BOOKING_BY_ID_LOAD_PENDING = 'BOOKING_BY_ID_LOAD_PENDING';
export const BOOKING_BY_ID_LOAD_SUCCESS = 'BOOKING_BY_ID_LOAD_SUCCESS';
export const BOOKING_BY_ID_LOAD_FAILURE = 'BOOKING_BY_ID_LOAD_FAILURE';
export const BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_PENDING = 'BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_PENDING';
export const BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_SUCCESS = 'BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_SUCCESS';
export const BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_FAILURE = 'BOOKING_STAY_PARTICIPANTS_BY_STAY_IDS_LOAD_FAILURE';
export const BOOKING_STAY_AREA_PENDING = 'BOOKING_STAY_AREA_PENDING';
export const BOOKING_STAY_AREA_SUCCESS = 'BOOKING_STAY_AREA_SUCCESS';
export const BOOKING_STAY_AREA_FAILURE = 'BOOKING_STAY_AREA_FAILURE';

/*
  -----------------

  Ski: Rental

  -----------------
 */

export const SKI_RENTAL_RESET_STATE = 'SKI_RENTAL_RESET_STATE';
export const SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_PENDING = 'SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_PENDING';
export const SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_SUCCESS = 'SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_SUCCESS';
export const SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_FAILURE = 'SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_FAILURE';
export const SKI_RENTAL_PRODUCTS_LOAD_PENDING = 'SKI_RENTAL_PRODUCTS_LOAD_PENDING';
export const SKI_RENTAL_PRODUCTS_LOAD_SUCCESS = 'SKI_RENTAL_PRODUCTS_LOAD_SUCCESS';
export const SKI_RENTAL_PRODUCTS_LOAD_FAILURE = 'SKI_RENTAL_PRODUCTS_LOAD_FAILURE';
export const SKI_RENTAL_PRODUCT_CREATE_PENDING = 'SKI_RENTAL_PRODUCT_CREATE_PENDING';
export const SKI_RENTAL_PRODUCT_CREATE_SUCCESS = 'SKI_RENTAL_PRODUCT_CREATE_SUCCESS';
export const SKI_RENTAL_PRODUCT_CREATE_FAILURE = 'SKI_RENTAL_PRODUCT_CREATE_FAILURE';
export const SKI_RENTAL_PRODUCT_UPDATE_PENDING = 'SKI_RENTAL_PRODUCT_UPDATE_PENDING';
export const SKI_RENTAL_PRODUCT_UPDATE_SUCCESS = 'SKI_RENTAL_PRODUCT_UPDATE_SUCCESS';
export const SKI_RENTAL_PRODUCT_UPDATE_FAILURE = 'SKI_RENTAL_PRODUCT_UPDATE_FAILURE';
export const SKI_RENTAL_PRODUCT_DELETE_PENDING = 'SKI_RENTAL_PRODUCT_DELETE_PENDING';
export const SKI_RENTAL_PRODUCT_DELETE_SUCCESS = 'SKI_RENTAL_PRODUCT_DELETE_SUCCESS';
export const SKI_RENTAL_PRODUCT_DELETE_FAILURE = 'SKI_RENTAL_PRODUCT_DELETE_FAILURE';
export const SKI_RENTAL_PRODUCT_CANCEL_PENDING = 'SKI_RENTAL_PRODUCT_CANCEL_PENDING';
export const SKI_RENTAL_PRODUCT_CANCEL_SUCCESS = 'SKI_RENTAL_PRODUCT_CANCEL_SUCCESS';
export const SKI_RENTAL_PRODUCT_CANCEL_FAILURE = 'SKI_RENTAL_PRODUCT_CANCEL_FAILURE';
export const SKI_RENTAL_PRODUCT_STOP_PENDING = 'SKI_RENTAL_PRODUCT_STOP_PENDING';
export const SKI_RENTAL_PRODUCT_STOP_SUCCESS = 'SKI_RENTAL_PRODUCT_STOP_SUCCESS';
export const SKI_RENTAL_PRODUCT_STOP_FAILURE = 'SKI_RENTAL_PRODUCT_STOP_FAILURE';
export const SKI_RENTAL_PRODUCT_PRICE_UPDATE_PENDING = 'SKI_RENTAL_PRODUCT_PRICE_UPDATE_PENDING';
export const SKI_RENTAL_PRODUCT_PRICE_UPDATE_SUCCESS = 'SKI_RENTAL_PRODUCT_PRICE_UPDATE_SUCCESS';
export const SKI_RENTAL_PRODUCT_PRICE_UPDATE_FAILURE = 'SKI_RENTAL_PRODUCT_PRICE_UPDATE_FAILURE';
export const SKI_RENTAL_PRODUCT_CHANGE_STATUS_PENDING = 'SKI_RENTAL_PRODUCT_CHANGE_STATUS_PENDING';
export const SKI_RENTAL_PRODUCT_CHANGE_STATUS_SUCCESS = 'SKI_RENTAL_PRODUCT_CHANGE_STATUS_SUCCESS';
export const SKI_RENTAL_PRODUCT_CHANGE_STATUS_FAILURE = 'SKI_RENTAL_PRODUCT_CHANGE_STATUS_FAILURE';
export const SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_PENDING = 'SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_PENDING';
export const SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_SUCCESS = 'SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_SUCCESS';
export const SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_FAILURE = 'SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_FAILURE';
export const SKI_RENTAL_PARTICIPANT_UPDATE_PENDING = 'SKI_RENTAL_PARTICIPANT_UPDATE_PENDING';
export const SKI_RENTAL_PARTICIPANT_UPDATE_SUCCESS = 'SKI_RENTAL_PARTICIPANT_UPDATE_SUCCESS';
export const SKI_RENTAL_PARTICIPANT_UPDATE_FAILURE = 'SKI_RENTAL_PARTICIPANT_UPDATE_FAILURE';
export const SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_PENDING = 'SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_PENDING';
export const SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_SUCCESS = 'SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_SUCCESS';
export const SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_FAILURE = 'SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_FAILURE';
export const SKI_RENTAL_PRODUCT_STATUS_UPDATE_PENDING = 'SKI_RENTAL_PRODUCT_STATUS_UPDATE_PENDING';
export const SKI_RENTAL_PRODUCT_STATUS_UPDATE_SUCCESS = 'SKI_RENTAL_PRODUCT_STATUS_UPDATE_SUCCESS';
export const SKI_RENTAL_PRODUCT_STATUS_UPDATE_FAILURE = 'SKI_RENTAL_PRODUCT_STATUS_UPDATE_FAILURE';
export const SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_PENDING = 'SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_PENDING';
export const SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_SUCCESS = 'SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_SUCCESS';
export const SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_FAILURE = 'SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_FAILURE';
export const SKI_RENTAL_SEARCH_BOOKING_PARTICIPANT_SET = 'SKI_RENTAL_SEARCH_BOOKING_PARTICIPANT_SET';
export const SKI_RENTAL_SEARCH_START_DATE_SET = 'SKI_RENTAL_SEARCH_START_DATE_SET';
export const SKI_RENTAL_SEARCH_NUMBER_OF_DAYS_SET = 'SKI_RENTAL_SEARCH_NUMBER_OF_DAYS_SET';
export const SKI_RENTAL_SEARCH_LEVEL_TYPES_SET = 'SKI_RENTAL_SEARCH_LEVEL_TYPES_SET';
export const SKI_RENTAL_SEARCH_SKI_TYPES_SET = 'SKI_RENTAL_SEARCH_SKI_TYPES_SET';
export const SKI_RENTAL_SEARCH_AREA_SET = 'SKI_RENTAL_SEARCH_AREA_SET';
export const SKI_RENTAL_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET = 'SKI_RENTAL_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET';
export const SKI_RENTAL_CHANGE_PRODUCT_START_DATE_SET = 'SKI_RENTAL_CHANGE_PRODUCT_START_DATE_SET';
export const SKI_RENTAL_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET = 'SKI_RENTAL_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET';
export const SKI_RENTAL_CHANGE_PRODUCT_PERSON_CATEGORY_SET = 'SKI_RENTAL_CHANGE_PRODUCT_PERSON_CATEGORY_SET';
export const SKI_RENTAL_CHANGE_PRODUCT_LEVEL_TYPE_SET = 'SKI_RENTAL_CHANGE_PRODUCT_LEVEL_TYPE_SET';
export const SKI_RENTAL_CHANGE_PRODUCT_SKI_TYPE_SET = 'SKI_RENTAL_CHANGE_PRODUCT_SKI_TYPE_SET';
export const SKI_RENTAL_CHANGE_PRODUCT_PACKAGE_TYPE_SET = 'SKI_RENTAL_CHANGE_PRODUCT_PACKAGE_TYPE_SET';
export const SKI_RENTAL_ASSIGN_PARTICIPANT_PENDING = 'SKI_RENTAL_ASSIGN_PARTICIPANT_PENDING';
export const SKI_RENTAL_ASSIGN_PARTICIPANT_SUCCESS = 'SKI_RENTAL_ASSIGN_PARTICIPANT_SUCCESS';
export const SKI_RENTAL_ASSIGN_PARTICIPANT_FAILURE = 'SKI_RENTAL_ASSIGN_PARTICIPANT_FAILURE';

export const BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_PENDING = 'BOOKING_GET_PICKUP_PLACES_PENDING';
export const BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_SUCCESS = 'BOOKING_GET_PICKUP_PLACES_SUCCESS';
export const BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_FAILURE = 'BOOKING_GET_PICKUP_PLACES_FAILURE';

export const BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_PENDING = 'BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_PENDING';
export const BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_SUCCESS = 'BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_SUCCESS';
export const BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_FAILURE = 'BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_FAILURE';

export const BOOKING_GET_SKI_PASS_PICKUP_PLACES_PENDING = 'BOOKING_GET_PICKUP_PLACES_PENDING';
export const BOOKING_GET_SKI_PASS_PICKUP_PLACES_SUCCESS = 'BOOKING_GET_PICKUP_PLACES_SUCCESS';
export const BOOKING_GET_SKI_PASS_PICKUP_PLACES_FAILURE = 'BOOKING_GET_PICKUP_PLACES_FAILURE';

export const BOOKING_SAVE_SKI_PASS_PICKUP_PLACE_PENDING = 'BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_PENDING';
export const BOOKING_SAVE_SKI_PASS_PICKUP_PLACE_SUCCESS = 'BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_SUCCESS';
export const BOOKING_SAVE_SKI_PASS_PICKUP_PLACE_FAILURE = 'BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_FAILURE';

/*
  -----------------

  Ski: Pass

  -----------------
 */
export const SKI_PASS_RESET_STATE = 'SKI_PASS_RESET_STATE';
export const SKI_PASS_AVAILABLE_PRODUCTS_LOAD_PENDING = 'SKI_PASS_AVAILABLE_PRODUCTS_LOAD_PENDING';
export const SKI_PASS_AVAILABLE_PRODUCTS_LOAD_SUCCESS = 'SKI_PASS_AVAILABLE_PRODUCTS_LOAD_SUCCESS';
export const SKI_PASS_AVAILABLE_PRODUCTS_LOAD_FAILURE = 'SKI_PASS_AVAILABLE_PRODUCTS_LOAD_FAILURE';
export const SKI_PASS_PRODUCTS_LOAD_PENDING = 'SKI_PASS_PRODUCTS_LOAD_PENDING';
export const SKI_PASS_PRODUCTS_LOAD_SUCCESS = 'SKI_PASS_PRODUCTS_LOAD_SUCCESS';
export const SKI_PASS_PRODUCTS_LOAD_FAILURE = 'SKI_PASS_PRODUCTS_LOAD_FAILURE';
export const SKI_PASS_CREATE_PENDING = 'SKI_PASS_CREATE_PENDING';
export const SKI_PASS_CREATE_SUCCESS = 'SKI_PASS_CREATE_SUCCESS';
export const SKI_PASS_CREATE_FAILURE = 'SKI_PASS_CREATE_FAILURE';
export const SKI_PASS_UPDATE_PENDING = 'SKI_PASS_UPDATE_PENDING';
export const SKI_PASS_UPDATE_SUCCESS = 'SKI_PASS_UPDATE_SUCCESS';
export const SKI_PASS_UPDATE_FAILURE = 'SKI_PASS_UPDATE_FAILURE';
export const SKI_PASS_DELETE_PENDING = 'SKI_PASS_DELETE_PENDING';
export const SKI_PASS_DELETE_SUCCESS = 'SKI_PASS_DELETE_SUCCESS';
export const SKI_PASS_DELETE_FAILURE = 'SKI_PASS_DELETE_FAILURE';
export const SKI_PASS_CANCEL_PENDING = 'SKI_PASS_CANCEL_PENDING';
export const SKI_PASS_CANCEL_SUCCESS = 'SKI_PASS_CANCEL_SUCCESS';
export const SKI_PASS_CANCEL_FAILURE = 'SKI_PASS_CANCEL_FAILURE';
export const SKI_PASS_STOP_PENDING = 'SKI_PASS_STOP_PENDING';
export const SKI_PASS_STOP_SUCCESS = 'SKI_PASS_STOP_SUCCESS';
export const SKI_PASS_STOP_FAILURE = 'SKI_PASS_STOP_FAILURE';
export const SKI_PASS_PRICE_UPDATE_PENDING = 'SKI_PASS_PRICE_UPDATE_PENDING';
export const SKI_PASS_PRICE_UPDATE_SUCCESS = 'SKI_PASS_PRICE_UPDATE_SUCCESS';
export const SKI_PASS_PRICE_UPDATE_FAILURE = 'SKI_PASS_PRICE_UPDATE_FAILURE';
export const SKI_PASS_CANCELLATION_FEE_NET_UPDATE_PENDING = 'SKI_PASS_CANCELLATION_FEE_NET_UPDATE_PENDING';
export const SKI_PASS_CANCELLATION_FEE_NET_UPDATE_SUCCESS = 'SKI_PASS_CANCELLATION_FEE_NET_UPDATE_SUCCESS';
export const SKI_PASS_CANCELLATION_FEE_NET_UPDATE_FAILURE = 'SKI_PASS_CANCELLATION_FEE_NET_UPDATE_FAILURE';
export const SKI_PASS_CHANGE_STATUS_PENDING = 'SKI_PASS_CHANGE_STATUS_PENDING';
export const SKI_PASS_CHANGE_STATUS_SUCCESS = 'SKI_PASS_CHANGE_STATUS_SUCCESS';
export const SKI_PASS_CHANGE_STATUS_FAILURE = 'SKI_PASS_CHANGE_STATUS_FAILURE';
export const SKI_PASS_SUPPLIER_REF_UPDATE_PENDING = 'SKI_PASS_SUPPLIER_REF_UPDATE_PENDING';
export const SKI_PASS_SUPPLIER_REF_UPDATE_SUCCESS = 'SKI_PASS_SUPPLIER_REF_UPDATE_SUCCESS';
export const SKI_PASS_SUPPLIER_REF_UPDATE_FAILURE = 'SKI_PASS_SUPPLIER_REF_UPDATE_FAILURE';
export const SKI_PASS_SEND_REQUEST_EMAIL_PENDING = 'SKI_PASS_SEND_REQUEST_EMAIL_PENDING';
export const SKI_PASS_SEND_REQUEST_EMAIL_SUCCESS = 'SKI_PASS_SEND_REQUEST_EMAIL_SUCCESS';
export const SKI_PASS_SEND_REQUEST_EMAIL_FAILURE = 'SKI_PASS_SEND_REQUEST_EMAIL_FAILURE';
export const SKI_PASS_SEARCH_BOOKING_PARTICIPANT_SET = 'SKI_PASS_SEARCH_BOOKING_PARTICIPANT_SET';
export const SKI_PASS_SEARCH_START_DATE_SET = 'SKI_PASS_SEARCH_START_DATE_SET';
export const SKI_PASS_SEARCH_NUMBER_OF_DAYS_SET = 'SKI_PASS_SEARCH_NUMBER_OF_DAYS_SET';
export const SKI_PASS_SEARCH_AREA_SET = 'SKI_PASS_SEARCH_AREA_SET';
export const SKI_PASS_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET = 'SKI_PASS_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET';
export const SKI_PASS_CHANGE_PRODUCT_START_DATE_SET = 'SKI_PASS_CHANGE_PRODUCT_START_DATE_SET';
export const SKI_PASS_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET = 'SKI_PASS_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET';
export const SKI_PASS_CHANGE_PRODUCT_PERSON_CATEGORY_SET = 'SKI_PASS_CHANGE_PRODUCT_PERSON_CATEGORY_SET';
export const SKI_PASS_ASSIGN_PARTICIPANT_PENDING = 'SKI_PASS_ASSIGN_PARTICIPANT_PENDING';
export const SKI_PASS_ASSIGN_PARTICIPANT_SUCCESS = 'SKI_PASS_ASSIGN_PARTICIPANT_SUCCESS';
export const SKI_PASS_ASSIGN_PARTICIPANT_FAILURE = 'SKI_PASS_ASSIGN_PARTICIPANT_FAILURE';

/*
  -----------------

  Ski: School

  -----------------
 */

export const SKI_SCHOOL_RESET_STATE = 'SKI_SCHOOL_RESET_STATE';
export const SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_PENDING = 'SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_PENDING';
export const SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_SUCCESS = 'SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_SUCCESS';
export const SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_FAILURE = 'SKI_SCHOOL_AVAILABLE_PRODUCTS_LOAD_FAILURE';
export const SKI_SCHOOL_PRODUCTS_LOAD_PENDING = 'SKI_SCHOOL_PRODUCTS_LOAD_PENDING';
export const SKI_SCHOOL_PRODUCTS_LOAD_SUCCESS = 'SKI_SCHOOL_PRODUCTS_LOAD_SUCCESS';
export const SKI_SCHOOL_PRODUCTS_LOAD_FAILURE = 'SKI_SCHOOL_PRODUCTS_LOAD_FAILURE';
export const SKI_SCHOOL_CREATE_PENDING = 'SKI_SCHOOL_CREATE_PENDING';
export const SKI_SCHOOL_CREATE_SUCCESS = 'SKI_SCHOOL_CREATE_SUCCESS';
export const SKI_SCHOOL_CREATE_FAILURE = 'SKI_SCHOOL_CREATE_FAILURE';
export const SKI_SCHOOL_UPDATE_PENDING = 'SKI_SCHOOL_UPDATE_PENDING';
export const SKI_SCHOOL_UPDATE_SUCCESS = 'SKI_SCHOOL_UPDATE_SUCCESS';
export const SKI_SCHOOL_UPDATE_FAILURE = 'SKI_SCHOOL_UPDATE_FAILURE';
export const SKI_SCHOOL_DELETE_PENDING = 'SKI_SCHOOL_DELETE_PENDING';
export const SKI_SCHOOL_DELETE_SUCCESS = 'SKI_SCHOOL_DELETE_SUCCESS';
export const SKI_SCHOOL_DELETE_FAILURE = 'SKI_SCHOOL_DELETE_FAILURE';
export const SKI_SCHOOL_CANCEL_PENDING = 'SKI_SCHOOL_CANCEL_PENDING';
export const SKI_SCHOOL_CANCEL_SUCCESS = 'SKI_SCHOOL_CANCEL_SUCCESS';
export const SKI_SCHOOL_CANCEL_FAILURE = 'SKI_SCHOOL_CANCEL_FAILURE';
export const SKI_SCHOOL_STOP_PENDING = 'SKI_SCHOOL_STOP_PENDING';
export const SKI_SCHOOL_STOP_SUCCESS = 'SKI_SCHOOL_STOP_SUCCESS';
export const SKI_SCHOOL_STOP_FAILURE = 'SKI_SCHOOL_STOP_FAILURE';
export const SKI_SCHOOL_PRICE_UPDATE_PENDING = 'SKI_SCHOOL_PRICE_UPDATE_PENDING';
export const SKI_SCHOOL_PRICE_UPDATE_SUCCESS = 'SKI_SCHOOL_PRICE_UPDATE_SUCCESS';
export const SKI_SCHOOL_PRICE_UPDATE_FAILURE = 'SKI_SCHOOL_PRICE_UPDATE_FAILURE';
export const SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_PENDING = 'SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_PENDING';
export const SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_SUCCESS = 'SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_SUCCESS';
export const SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_FAILURE = 'SKI_SCHOOL_CANCELLATION_FEE_NET_UPDATE_FAILURE';
export const SKI_SCHOOL_CHANGE_STATUS_PENDING = 'SKI_SCHOOL_CHANGE_STATUS_PENDING';
export const SKI_SCHOOL_CHANGE_STATUS_SUCCESS = 'SKI_SCHOOL_CHANGE_STATUS_SUCCESS';
export const SKI_SCHOOL_CHANGE_STATUS_FAILURE = 'SKI_SCHOOL_CHANGE_STATUS_FAILURE';
export const SKI_SCHOOL_SUPPLIER_REF_UPDATE_PENDING = 'SKI_SCHOOL_SUPPLIER_REF_UPDATE_PENDING';
export const SKI_SCHOOL_SUPPLIER_REF_UPDATE_SUCCESS = 'SKI_SCHOOL_SUPPLIER_REF_UPDATE_SUCCESS';
export const SKI_SCHOOL_SUPPLIER_REF_UPDATE_FAILURE = 'SKI_SCHOOL_SUPPLIER_REF_UPDATE_FAILURE';
export const SKI_SCHOOL_STATUS_UPDATE_PENDING = 'SKI_SCHOOL_STATUS_UPDATE_PENDING';
export const SKI_SCHOOL_STATUS_UPDATE_SUCCESS = 'SKI_SCHOOL_STATUS_UPDATE_SUCCESS';
export const SKI_SCHOOL_STATUS_UPDATE_FAILURE = 'SKI_SCHOOL_STATUS_UPDATE_FAILURE';
export const SKI_SCHOOL_SEARCH_BOOKING_PARTICIPANT_SET = 'SKI_SCHOOL_SEARCH_BOOKING_PARTICIPANT_SET';
export const SKI_SCHOOL_SEARCH_NUMBER_OF_DAYS_SET = 'SKI_SCHOOL_SEARCH_NUMBER_OF_DAYS_SET';
export const SKI_SCHOOL_SEARCH_AREA_SET = 'SKI_SCHOOL_SEARCH_AREA_SET';
export const SKI_SCHOOL_SEARCH_LESSON_TYPE_SET = 'SKI_SCHOOL_SEARCH_LESSON_TYPE_SET';
export const SKI_SCHOOL_SEARCH_WEEK_DAY_NUMBER_SET = 'SKI_SCHOOL_SEARCH_WEEK_DAY_NUMBER_SET';
export const SKI_SCHOOL_SEARCH_LESSON_DURATION_SET = 'SKI_SCHOOL_SEARCH_LESSON_DURATION_SET';
export const SKI_SCHOOL_SEARCH_NUMBER_OF_PERSONS_SET = 'SKI_SCHOOL_SEARCH_NUMBER_OF_PERSONS_SET';
export const SKI_SCHOOL_SEARCH_SKI_TYPES_SET = 'SKI_SCHOOL_SEARCH_SKI_TYPES_SET';
export const SKI_SCHOOL_SEARCH_CLEAR_FILTERS_SET = 'SKI_SCHOOL_SEARCH_CLEAR_FILTERS_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_PERSON_CATEGORY_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_PERSON_CATEGORY_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_AREA_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_AREA_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_LESSON_TYPE_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_LESSON_TYPE_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_WEEK_DAY_NUMBER_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_WEEK_DAY_NUMBER_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_LESSON_DURATION_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_LESSON_DURATION_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_LEVEL_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_LEVEL_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_NUMBER_OF_PERSONS_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_NUMBER_OF_PERSONS_SET';
export const SKI_SCHOOL_CHANGE_PRODUCT_SKI_TYPE_SET = 'SKI_SCHOOL_CHANGE_PRODUCT_SKI_TYPE_SET';
export const SKI_SCHOOL_PARTICIPANT_CREATE_PENDING = 'SKI_SCHOOL_PARTICIPANT_CREATE_PENDING';
export const SKI_SCHOOL_PARTICIPANT_CREATE_SUCCESS = 'SKI_SCHOOL_PARTICIPANT_CREATE_SUCCESS';
export const SKI_SCHOOL_PARTICIPANT_CREATE_FAILURE = 'SKI_SCHOOL_PARTICIPANT_CREATE_FAILURE';
export const SKI_SCHOOL_PARTICIPANT_DELETE_PENDING = 'SKI_SCHOOL_PARTICIPANT_DELETE_PENDING';
export const SKI_SCHOOL_PARTICIPANT_DELETE_SUCCESS = 'SKI_SCHOOL_PARTICIPANT_DELETE_SUCCESS';
export const SKI_SCHOOL_PARTICIPANT_DELETE_FAILURE = 'SKI_SCHOOL_PARTICIPANT_DELETE_FAILURE';
export const SKI_SCHOOL_START_DATE_TIME_UPDATE_PENDING = 'SKI_SCHOOL_START_DATE_TIME_UPDATE_PENDING';
export const SKI_SCHOOL_START_DATE_TIME_UPDATE_SUCCESS = 'SKI_SCHOOL_START_DATE_TIME_UPDATE_SUCCESS';
export const SKI_SCHOOL_START_DATE_TIME_UPDATE_FAILURE = 'SKI_SCHOOL_START_DATE_TIME_UPDATE_FAILURE';
export const SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_PENDING = 'SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_PENDING';
export const SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_SUCCESS = 'SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_SUCCESS';
export const SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_FAILURE = 'SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_FAILURE';
export const SKI_SCHOOL_CUSTOMER_COMMENT_UPDATE_PENDING = 'SKI_SCHOOL_SUPPLIER_COMMENT_UPDATE_FAILURE';
export const SKI_SCHOOL_CUSTOMER_COMMENT_UPDATE_SUCCESS = 'SKI_SCHOOL_CUSTOMER_COMMENT_UPDATE_SUCCESS';
export const SKI_SCHOOL_CUSTOMER_COMMENT_UPDATE_FAILURE = 'SKI_SCHOOL_CUSTOMER_COMMENT_UPDATE_FAILURE';
export const SKI_SCHOOL_SEND_REQUEST_EMAIL_PENDING = 'SKI_SCHOOL_SEND_REQUEST_EMAIL_PENDING';
export const SKI_SCHOOL_SEND_REQUEST_EMAIL_SUCCESS = 'SKI_SCHOOL_SEND_REQUEST_EMAIL_SUCCESS';
export const SKI_SCHOOL_SEND_REQUEST_EMAIL_FAILURE = 'SKI_SCHOOL_SEND_REQUEST_EMAIL_FAILURE';
export const SKI_SCHOOL_MEETING_POINTS_LOAD_PENDING = 'SKI_SCHOOL_MEETING_POINTS_LOAD_PENDING';
export const SKI_SCHOOL_MEETING_POINTS_LOAD_SUCCESS = 'SKI_SCHOOL_MEETING_POINTS_LOAD_SUCCESS';
export const SKI_SCHOOL_MEETING_POINTS_LOAD_FAILURE = 'SKI_SCHOOL_MEETING_POINTS_LOAD_FAILURE';
export const SKI_SCHOOL_MEETING_POINT_UPDATE_PENDING = 'SKI_SCHOOL_MEETING_POINT_UPDATE_PENDING';
export const SKI_SCHOOL_MEETING_POINT_UPDATE_SUCCESS = 'SKI_SCHOOL_MEETING_POINT_UPDATE_SUCCESS';
export const SKI_SCHOOL_MEETING_POINT_UPDATE_FAILURE = 'SKI_SCHOOL_MEETING_POINT_UPDATE_FAILURE';

/*
  -----------------

  Reminders

  -----------------
 */
export const REMINDERS_RESET = 'REMINDER_RESET';
export const REMINDERS_DOMAINS_PENDING = 'REMINDERS_DOMAINS_PENDING';
export const REMINDERS_DOMAINS_SUCCESS = 'REMINDERS_DOMAINS_SUCCESS';
export const REMINDERS_DOMAINS_FAILURE = 'REMINDERS_DOMAINS_FAILURE';
export const REMINDERS_DOMAINS_NO_CONTENT = 'REMINDERS_DOMAINS_NO_CONTENT';

export const REMINDERS_TEMPLATES_DOMAIN_SET = 'REMINDERS_TEMPLATES_DOMAIN_SET';
export const REMINDERS_TEMPLATES_PENDING = 'REMINDERS_TEMPLATES_PENDING';
export const REMINDERS_TEMPLATES_SUCCESS = 'REMINDERS_TEMPLATES_SUCCESS';
export const REMINDERS_TEMPLATES_FAILURE = 'REMINDERS_TEMPLATES_FAILURE';
export const REMINDERS_TEMPLATES_NO_CONTENT = 'REMINDERS_TEMPLATES_NO_CONTENT';
export const REMINDERS_TEMPLATE_SAVE_PENDING = 'REMINDERS_TEMPLATE_SAVE_PENDING';
export const REMINDERS_TEMPLATE_SAVE_SUCCESS = 'REMINDERS_TEMPLATE_SAVE_SUCCESS';
export const REMINDERS_TEMPLATE_SAVE_FAILURE = 'REMINDERS_TEMPLATE_SAVE_FAILURE';

export const REMINDERS_RULES_DOMAIN_SET = 'REMINDERS_RULES_DOMAIN_SET';
export const REMINDERS_RULES_PENDING = 'REMINDERS_RULES_PENDING';
export const REMINDERS_RULES_SUCCESS = 'REMINDERS_RULES_SUCCESS';
export const REMINDERS_RULES_FAILURE = 'REMINDERS_RULES_FAILURE';
export const REMINDERS_RULES_NO_CONTENT = 'REMINDERS_RULES_NO_CONTENT';
export const REMINDERS_RULES_TEMPLATES_ADD = 'REMINDERS_RULES_TEMPLATES_ADD';
export const REMINDERS_RULES_TEMPLATES_DELETE = 'REMINDERS_RULES_TEMPLATES_DELETE';
export const REMINDERS_RULES_TEMPLATES_PENDING = 'REMINDERS_RULES_TEMPLATES_PENDING';
export const REMINDERS_RULES_TEMPLATES_SUCCESS = 'REMINDERS_RULES_TEMPLATES_SUCCESS';
export const REMINDERS_RULES_TEMPLATES_FAILURE = 'REMINDERS_RULES_TEMPLATES_FAILURE';
export const REMINDERS_RULES_TEMPLATES_UPDATE = 'REMINDERS_RULES_TEMPLATES_UPDATE';
export const REMINDERS_RULES_TEMPLATES_NO_CONTENT = 'REMINDERS_RULES_TEMPLATES_NO_CONTENT';
export const REMINDERS_RULES_TEMPLATES_SWAP_ORDER = 'REMINDERS_RULES_TEMPLATES_SWAP_ORDER';
export const REMINDERS_RULES_SAVE_PENDING = 'REMINDERS_RULES_SAVE_PENDING';
export const REMINDERS_RULES_SAVE_SUCCESS = 'REMINDERS_RULES_SAVE_SUCCESS';
export const REMINDERS_RULES_SAVE_FAILURE = 'REMINDERS_RULES_SAVE_FAILURE';
export const REMINDERS_RULES_REVISIONS_PENDING = 'REMINDERS_RULES_REVISIONS_PENDING';
export const REMINDERS_RULES_REVISIONS_SUCCESS = 'REMINDERS_RULES_REVISIONS_SUCCESS';
export const REMINDERS_RULES_REVISIONS_FAILURE = 'REMINDERS_RULES_REVISIONS_FAILURE';
export const REMINDERS_RULES_REVISIONS_NO_CONTENT = 'REMINDERS_RULES_REVISIONS_NO_CONTENT';
export const REMINDERS_RULES_REVISIONS_CURRENT = 'REMINDERS_RULES_REVISIONS_CURRENT';
export const REMINDERS_RULES_SETTINGS_PENDING = 'REMINDERS_RULES_SETTINGS_PENDING';
export const REMINDERS_RULES_SETTINGS_SUCCESS = 'REMINDERS_RULES_SETTINGS_SUCCESS';
export const REMINDERS_RULES_SETTINGS_FAILURE = 'REMINDERS_RULES_SETTINGS_FAILURE';
export const REMINDERS_RULES_SETTINGS_NO_CONTENT = 'REMINDERS_RULES_SETTINGS_NO_CONTENT';
export const REMINDERS_RULES_SETTINGS_ACTION_PENDING = 'REMINDERS_RULES_SETTINGS_ACTION_PENDING';
export const REMINDERS_RULES_SETTINGS_ACTION_SUCCESS = 'REMINDERS_RULES_SETTINGS_ACTION_SUCCESS';
export const REMINDERS_RULES_SETTINGS_ACTION_FAILURE = 'REMINDERS_RULES_SETTINGS_ACTION_FAILURE';
export const REMINDERS_RULES_SETTINGS_DELETE_PENDING = 'REMINDERS_RULES_SETTINGS_DELETE_PENDING';
export const REMINDERS_RULES_SETTINGS_DELETE_SUCCESS = 'REMINDERS_RULES_SETTINGS_DELETE_SUCCESS';
export const REMINDERS_RULES_SETTINGS_DELETE_FAILURE = 'REMINDERS_RULES_SETTINGS_DELETE_FAILURE';
export const REMINDERS_RULES_SETTINGS_LOGS_PENDING = 'REMINDERS_RULES_SETTINGS_LOGS_PENDING';
export const REMINDERS_RULES_SETTINGS_LOGS_SUCCESS = 'REMINDERS_RULES_SETTINGS_LOGS_SUCCESS';
export const REMINDERS_RULES_SETTINGS_LOGS_FAILURE = 'REMINDERS_RULES_SETTINGS_LOGS_FAILURE';

export const REMINDERS_LISTS_PREVIEW_PENDING = 'REMINDERS_LISTS_PREVIEW_PENDING';
export const REMINDERS_LISTS_PREVIEW_SUCCESS = 'REMINDERS_LISTS_PREVIEW_SUCCESS';
export const REMINDERS_LISTS_PREVIEW_FAILURE = 'REMINDERS_LISTS_PREVIEW_FAILURE';
export const REMINDERS_LISTS_OVERVIEW_PENDING = 'REMINDERS_LISTS_OVERVIEW_PENDING';
export const REMINDERS_LISTS_OVERVIEW_SUCCESS = 'REMINDERS_LISTS_OVERVIEW_SUCCESS';
export const REMINDERS_LISTS_OVERVIEW_FAILURE = 'REMINDERS_LISTS_OVERVIEW_FAILURE';
export const REMINDERS_LISTS_LIST_PENDING = 'REMINDERS_LISTS_LIST_PENDING';
export const REMINDERS_LISTS_LIST_SUCCESS = 'REMINDERS_LISTS_LIST_SUCCESS';
export const REMINDERS_LISTS_LIST_FAILURE = 'REMINDERS_LISTS_LIST_FAILURE';
export const REMINDERS_LISTS_MESSAGES_PENDING = 'REMINDERS_LISTS_MESSAGES_PENDING';
export const REMINDERS_LISTS_MESSAGES_SUCCESS = 'REMINDERS_LISTS_MESSAGES_SUCCESS';
export const REMINDERS_LISTS_MESSAGES_FAILURE = 'REMINDERS_LISTS_MESSAGES_FAILURE';
export const REMINDERS_LISTS_FILTERS_UPDATE = 'REMINDERS_LISTS_FILTERS_UPDATE';

/*
  -----------------

  Affiliate

  -----------------
 */
export const AFFILIATES_RESET = 'AFFILIATES_RESET';
export const AFFILIATES_PENDING = 'AFFILIATES_PENDING';
export const AFFILIATES_SUCCESS = 'AFFILIATES_SUCCESS';
export const AFFILIATES_FAILURE = 'AFFILIATES_FAILURE';
export const AFFILIATES_NO_CONTENT = 'AFFILIATES_NO_CONTENT';
export const AFFILIATES_DOMAINS_PENDING = 'AFFILIATES_DOMAINS_PENDING';
export const AFFILIATES_DOMAINS_SUCCESS = 'AFFILIATES_DOMAINS_SUCCESS';
export const AFFILIATES_DOMAINS_FAILURE = 'AFFILIATES_DOMAINS_FAILURE';
export const AFFILIATES_AFFILIATE_PENDING = 'AFFILIATES_AFFILIATE_PENDING';
export const AFFILIATES_AFFILIATE_SUCCESS = 'AFFILIATES_AFFILIATE_SUCCESS';
export const AFFILIATES_AFFILIATE_FAILURE = 'AFFILIATES_AFFILIATE_FAILURE';
export const AFFILIATES_AFFILIATE_UPDATE_PENDING = 'AFFILIATES_AFFILIATE_UPDATE_PENDING';
export const AFFILIATES_AFFILIATE_UPDATE_SUCCESS = 'AFFILIATES_AFFILIATE_UPDATE_SUCCESS';
export const AFFILIATES_AFFILIATE_UPDATE_FAILURE = 'AFFILIATES_AFFILIATE_UPDATE_FAILURE';
export const AFFILIATES_AFFILIATE_LOGO_PENDING = 'AFFILIATES_AFFILIATE_LOGO_PENDING';
export const AFFILIATES_AFFILIATE_LOGO_SUCCESS = 'AFFILIATES_AFFILIATE_LOGO_SUCCESS';
export const AFFILIATES_AFFILIATE_LOGO_FAILURE = 'AFFILIATES_AFFILIATE_LOGO_FAILURE';
export const AFFILIATES_AFFILIATE_SUPPLIERS_SET = 'AFFILIATES_AFFILIATE_SUPPLIERS_SET';
export const AFFILIATES_AFFILIATE_SUPPLIERS_ADD = 'AFFILIATES_AFFILIATE_SUPPLIERS_ADD';
export const AFFILIATES_AFFILIATE_SUPPLIERS_REMOVE = 'AFFILIATES_AFFILIATE_SUPPLIERS_REMOVE';
export const AFFILIATES_AFFILIATE_SUPPLIERS_PENDING = 'AFFILIATES_AFFILIATE_SUPPLIERS_PENDING';
export const AFFILIATES_AFFILIATE_SUPPLIERS_SUCCESS = 'AFFILIATES_AFFILIATE_SUPPLIERS_SUCCESS';
export const AFFILIATES_AFFILIATE_SUPPLIERS_FAILURE = 'AFFILIATES_AFFILIATE_SUPPLIERS_FAILURE';
export const AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_PENDING = 'AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_PENDING';
export const AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_SUCCESS = 'AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_SUCCESS';
export const AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_FAILURE = 'AFFILIATES_AFFILIATE_SUPPLIERS_SYNC_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/constants.js